import React, {PureComponent} from 'react'
import StyleSheet from 'styles'
import { Typography } from 'components/OptimisedMui'
import {LinkButton} from 'components'

export class StagesReview extends PureComponent {
  static defaultProps = {
    name: 'Review',
    title: 'Review',
    review: true
  }

  render = () => {
    const {context, onStageChange, stages} = this.props
    return (
      <div>
        {(stages || []).filter(s => !s.review).map(({component}, i) =>
          <div className={styles.review} key={i}>
            <div className={styles.headline}>
              <Typography variant="h5">{i+1}. {component.props.title}</Typography>
              <LinkButton className={styles.editLink} onClick={() => onStageChange(i)}>Edit</LinkButton>
            </div>
            {React.cloneElement(component, {review: true, context})}
          </div>
        )}
      </div>
    )
  }
}

export default StagesReview

const styles = StyleSheet({
  review: {
    paddingBottom: 50,
    '& button': {
      display: 'none'
    },
    '& a:not([target=_blank])': {
      display: 'none'
    },
    '@media print': {
      paddingBottom: 15
    }
  },
  editLink: {
    display: 'inline !important',
    'button&': {
      color: '#6AAEAA',
      fontWeight: 'bold',
      fontSize: '14px',
    },
    '@media print': {
      display: 'none !important'
    }
  },
  headline: {
    '& h5': {
      marginBottom: '0 !important',
    },
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    borderBottom: '1px solid #1B3044',
    marginBottom: 30,
  }
})